import { render, staticRenderFns } from "./product-icon.vue?vue&type=template&id=11e3e166&functional=true&"
import script from "./product-icon.vue?vue&type=script&lang=js&"
export * from "./product-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports